module.exports = __webpack_public_path__ + "static/media/shopify.22b9f7a4.svg";